import styled from 'styled-components';
import { useState, useEffect, useCallback, useRef } from 'react';
// components
import Icon from 'cds/icons';
import OutlineButton from 'cds/buttons/Outline';
import TextButton from 'cds/buttons/Text';
// styles
import { mediaQuery, palette } from 'cds/styles';
import * as typography from 'cds/typography';
import { getKoreaDate } from 'lib/utils/format/time';

/**
 * 드롭다운
 * @param {object} props
 * @param {string} props.sortName
 * @param {string[]} props.itemList
 * @param {(name: string) => void} props.onClickItem
 *
 * @examples
 * <Dropdown sortName='최신순' itemList={['최신순', '인기순', '가격순']} />
 */
const FilterDropdown = ({ sortName = '', itemList, onClickItem }) => {
  const [isShow, setIsShow] = useState(false);
  const [displayItem, setDisplayItem] = useState(sortName);
  const target = useRef(null);

  const onSelectItem = item => {
    setIsShow(false);
    setDisplayItem(item);
    onClickItem(item);
  };

  const onClose = useCallback(e => {
    const path = e.path || (e.composedPath && e.composedPath());
    if (!path.includes(target.current)) {
      setIsShow(false);
    }
  }, []);

  const onToggleDialog = e => {
    setIsShow(v => !v);
    onClickLayout(e);
  };

  useEffect(() => {
    if (isShow) {
      document.addEventListener('click', onClose);
    }

    return () => document.removeEventListener('click', onClose);
  }, [isShow, onClose, sortName]);

  useEffect(() => setDisplayItem(sortName), [sortName]);

  useEffect(() => setDisplayItem(sortName), [sortName]);

  const filteredList = itemList.filter(v => v !== displayItem);
  const FilteredList = filteredList.map(item => (
    <UnSelectedButton key={item} size="Regular" onClick={() => onSelectItem(item)}>
      {item}
    </UnSelectedButton>
  ));

  // Data Mining을 위한 클릭 로직 추가

  const onClickLayout = e => {
    const text = e.target.textContent;
    let sort = sessionStorage.getItem('filterTypes');

    if (!sort) {
      sessionStorage.setItem(
        'filterTypes',
        JSON.stringify([
          {
            text,
            timeStamp: getKoreaDate(),
          },
        ]),
      );
      return;
    }

    if (sort !== null) {
      sort = JSON.parse(sort);
      if (sort[sort.length - 1].text !== text) {
        sort.push({ text, timeStamp: getKoreaDate() });
        sessionStorage.setItem('filterTypes', JSON.stringify(sort));
      }
    }
  };

  return (
    <Layout ref={target}>
      <SelectedButton
        onClick={e => {
          onToggleDialog(e);
        }}
        isShow={isShow}
      >
        {displayItem}
        <Icon name="ic_arrow_down_r" fill={palette.grey50} width={24} height={24} />
      </SelectedButton>
      {isShow && <Dialog>{FilteredList}</Dialog>}
    </Layout>
  );
};

const Layout = styled.div`
  display: none;
  position: relative;
  width: 132px;

  ${mediaQuery.large} {
    display: block;
  }
`;

const SelectedButton = styled(OutlineButton)`
  flex-grow: 0;
  width: 124px;
  height: 40px;
  padding: 0 8px 0 16px;
  margin-left: 8px;
  ${typography.body3_regular}
  color: ${palette.grey50};
  background-color: ${palette.BTN.BG};
  border: none !important;
  & svg {
    margin-left: 2px;
    transform: ${({ isShow }) => (isShow ? `rotate(180deg)` : 'rotate(0deg)')};
  }
`;

const Dialog = styled.div`
  position: absolute;
  width: calc(100% - 8px);
  top: calc(100% + 2px);
  right: 0;
  border: none;
  border-radius: 4px;
  overflow: hidden;
`;

const UnSelectedButton = styled(TextButton)`
  width: 100%;
  font-size: 14px;
  border-radius: 0;
  ${typography.body3_regular}
  color: ${palette.grey50};
  background-color: ${palette.system.BNB};
`;

export default FilterDropdown;
